import InvoiceGeneratorTab from './tabs/InvoiceGeneratorTab';

export const invoiceToolsTabs = {
  'invoice-generator': {
    title: 'Invoice Generator',
    component: InvoiceGeneratorTab,
  },
} as const;

export const invoiceToolsTabsList = Object.keys(invoiceToolsTabs);

export type InvoiceToolsTab = keyof typeof invoiceToolsTabs;
